function mmReadMore(extract, full, section) {
    const sectionId = document.querySelector(section);

    const isMobile = window.matchMedia("(max-width: 767px)").matches;

    if (isMobile) {
        sectionId.querySelector(extract).style.display = "none";
        sectionId.querySelector(full).style.display = "inline-block";
    }
}
